import type React from 'react';

import type { IconProps } from 'types/icon';

const Plus: React.FC<IconProps> = ({
  size = '20',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...attributes}
    >
      <path
        d="M11.5 20.25V12.5H3.75C3.47386 12.5 3.25 12.2761 3.25 12C3.25 11.7239 3.47386 11.5 3.75 11.5H11.5V3.75C11.5 3.47386 11.7239 3.25 12 3.25C12.2761 3.25 12.5 3.47386 12.5 3.75V11.5H20.25C20.5261 11.5 20.75 11.7239 20.75 12C20.75 12.2761 20.5261 12.5 20.25 12.5H12.5V20.25C12.5 20.5261 12.2761 20.75 12 20.75C11.7239 20.75 11.5 20.5261 11.5 20.25Z"
        fill={color}
      />
    </svg>
  );
};

export default Plus;
